export default {
  methods: {
    // 日期选择器 RtDatePicker
    inputFocus () {
      if (!this.disabled) {
        this.$refs.input.focus();
        this.$refs.input.handleClick();
      }
    },
    // 日期时间选择器 DatetimePicker
    getTimeFocus () {
      if (!this.disabled) {
        this.$refs.timePicker.focus();
        this.$refs.timePicker.handleClick();
      }
    }
  }
};



// WEBPACK FOOTER //
// ./~/vue-xpc/src/components/form/inputFocusMixins.js